var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossCircleIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2564 0C4.59195 0 0 4.47715 0 10C0 15.5228 4.59195 20 10.2564 20C15.9209 20 20.5128 15.5228 20.5128 10C20.5062 4.47982 15.9181 0.00642897 10.2564 0Z",
    fill: "#FFF0B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50517 5.52827C5.76552 5.26792 6.18763 5.26792 6.44798 5.52827L9.97657 9.05687L13.5052 5.52827C13.7655 5.26792 14.1876 5.26792 14.448 5.52827C14.7083 5.78862 14.7083 6.21073 14.448 6.47108L10.9194 9.99967L14.448 13.5283C14.7083 13.7886 14.7083 14.2107 14.448 14.4711C14.1876 14.7314 13.7655 14.7314 13.5052 14.4711L9.97657 10.9425L6.44798 14.4711C6.18763 14.7314 5.76552 14.7314 5.50517 14.4711C5.24482 14.2107 5.24482 13.7886 5.50517 13.5283L9.03376 9.99967L5.50517 6.47108C5.24482 6.21073 5.24482 5.78862 5.50517 5.52827Z",
    fill: "#017C57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircleIcon);
export default __webpack_public_path__ + "static/media/cross-circle-icon.9d5c635747cc53276c3a09f0b073a90a.svg";
export { ForwardRef as ReactComponent };